<template>
  <SvgIcon
    v-if="sportId !== null"
    :name="`sport-${icon}`"
    :size="size"
  />
</template>
<script setup>
import SvgIcon from '@/components/Icons/SvgIcon.vue'
import { useSport } from '@/composables/useSport.js'

const props = defineProps({
  sportId: {
    type: Number,
    default: 0,
  },
  size: {
    type: String,
    default: '',
  },
})

const { icon } = useSport(() => props.sportId)
</script>
